/*
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-05-05 20:59:00
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-05-23 11:47:59
 * @FilePath: /streamline_detail/utils/useBigImages.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import { setPicSize } from '@zz-common/zz-utils'
import { ImagePreview } from '@zz-common/zz-ui'
Vue.use(ImagePreview)
// $ 图文视频预览
export const previewImgClick = (imgList, videoVos = [], start = 0, callback) => {
  ImagePreview({
    images: imgList,
    videoVos,
    withVideo: !!videoVos.length,
    startPosition: start,
    adaptApp: true,
    adaptWeixin: true,
    showClose: true,
    showLoading: true,
    loop: false,
    onClose: ({ url, index }) => {
      callback && callback({ url, index })
    },
  })
}
